import slick from 'slick-carousel';

$('.center').slick({
    centerMode: true,
    centerPadding: '100px',
    slidesToShow: 3,
    focusOnSelect: true,
    dots: false,
    infinite: true,
    prevArrow: $('.center-prev'),
    nextArrow: $('.center-next'),
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }
    ]
});

$('.banners').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    appendDots: $('.dots-banners'),
    prevArrow: $('.banner-prev'),
    nextArrow: $('.banner-next'),
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        },
    },
    {
        breakpoint: 784,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        },
    },
    ],
});

var swiper = new Swiper(".mySwiper", {
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

const btnNext = document.querySelector('.btn-next');
const btnPrev = document.querySelector('.btn-prev');

btnNext.addEventListener('click', () => {
    swiper.slideNext();
});

btnPrev.addEventListener('click', () => {
    swiper.slidePrev();
});
